import { useEffect } from 'react';
import { usePrevious } from 'rooks';
import { useLocation, useNavigate, matchPath } from 'react-router-dom';
import { getApplicationAccessLink, APPLICATIONS } from '~/components/ApplicationUrls';
import { LEGACY_HASH_TO_ROUTE_MAP } from '../helpers';
import { useUserAuth } from '~/components/Auth';

export const Redirection = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const previousHash = usePrevious(hash);
  const auth = useUserAuth();

  // eslint-disable-next-line complexity
  useEffect(() => {
    if (!!hash && previousHash !== hash) {
      const urlFragment = hash.split(/[#]/)[1];
      // hard-coded for callai
      if (urlFragment.includes('/callai')) {
        navigate(LEGACY_HASH_TO_ROUTE_MAP['/callai'](urlFragment), { replace: true });
      } else if (urlFragment.includes('/singleton-callai')) {
        navigate(LEGACY_HASH_TO_ROUTE_MAP['/singleton-callai'](urlFragment), { replace: true });
      } else {
        const key = Object.keys(LEGACY_HASH_TO_ROUTE_MAP).find((key: string) =>
          matchPath(key, urlFragment.split(/[?]/)[0])
        );
        const url = key
          ? LEGACY_HASH_TO_ROUTE_MAP[key](urlFragment, auth?.id, auth)
          : getApplicationAccessLink(APPLICATIONS.LEARNER_LEGACY_URL, { hash });
        // eslint-disable-next-line max-depth
        url && navigate(url, { replace: true });
      }
    }
  }, [hash, navigate, previousHash]);

  return null;
};

export default Redirection;
